export default {
    TITLES: {
        LOGIN: "Login",
        ENTER_PIN: "Enter PIN",
        OTP: "Enter OTP",
        FORGOT_PASS: "Forgot Password",
        CHANGE_PASS: "Set a New Password",
        TOTP: "Enter TOTP"
    },
    LABELS: {
        USER_ID: "Client Id*",
        USER_ID_MOBILE_NO: "Client Id/Mobile No.*",
        MOBILE_ID: "Mobile Number*",
        MOBILE_ID: "Mobile No.*",
        PASSWORD: "Password*",
        SUBMIT: "Submit",
        SIGN_UP: "Sign Up",
        OLD_PASSWORD: "Old Password",
        NEW_PASSWORD: "New Password",
        CONFIRM_PASSWORD: "Confirm Password",
        LOGIN_WITH_OTP: "Login with OTP",
        LOGIN_WITH_TOTP: "Login with TOTP",
        OTP: "OTP*"
    },
    MESSAGES: {
        ENTER_PIN_INFO: "Please enter the last 4 digits of your registered mobile number.",
        ENTER_TOTP_INFO: "Use your mobile authenticator app to generate a 6 digit TOTP",
        ENTER_OTP_INFO: "Please enter OTP sent to your registered Mobile No & Email ID",
        PIN_SET_SUCCESS: "Your new Pin is set successfully.",
        FIRST_LOGIN_CHANGE_PASS: "Kindly change the password as you are logging in for the first time.",
    },
    ERRORS: {
        E_USER_ID: "Client Id is required",
        E_VALID_USER_ID: "Please enter valid Client Id/Mobile No.",
        E_PASSWORD: "Password is required",
        E_PASSWORD_MATCH: "Password does not match New Password",
        E_PASSWORD_CHECK: "Please check your password and submit again",
        E_PIN: "Pin length must be 4 digits",
        E_PIN_MATCH: "Pin does not match New Pin",
        E_VALID_OTP: "Please enter valid OTP",
        VALID_EMAIL_MOBILE: "Enter valid Mobile No.",
        E_TOTP_LENGTH: "Totp length must be 6 digits",
        E_OTP_LENGTH: "Otp length must be 6 digits",
        E_TOTP: "TOTP is required",
        E_OTP: "OTP is required",
    }
};
